import type { KAPLAYCtx } from '../types.ts'
import { usePrintRoom } from './print-room.ts'
import { useFocusRoomA } from './focus-room-a.ts'
import { useFocusRoomB } from './focus-room-b.ts'
import { useTreadmillRoom } from './treadmill-room.ts'
import { useWC } from './wc.ts'
import { useWCB } from './wc-b.ts'
import { useWCHandicap } from './wc-handicap.ts'
import { useWCFemale } from './wc-female.ts'
import { useWCMale } from './wc-male.ts'
import { useWellbeingRoom } from './wellbeing-room.ts'
import { useTrainingRoom } from './training-room.ts'
import { useMedicalRoom } from './medical-room.ts'
import { useMothersRoom } from './mothers-room.ts'
import { useGreenRoom } from './green-room.ts'
import { useMultifaithRoom } from './multifaith-room.ts'
import { useMeetingRoomA } from './meeting-room-a.ts'
import { useMeetingRoomB } from './meeting-room-b.ts'
import { useMeetingRoomC } from './meeting-room-c.ts'
import { useMeetingRoomD } from './meeting-room-d.ts'
import { useMeetingRoomE } from './meeting-room-e.ts'
import { useMeetingRoomF } from './meeting-room-f.ts'
import { useMeetingRoomG } from './meeting-room-g.ts'
import { useMeetingRoomH } from './meeting-room-h.ts'
import { useMeetingRoomI } from './meeting-room-i.ts'
import { useMeetingRoomJ } from './meeting-room-j.ts'
import { useMeetingRoomK } from './meeting-room-k.ts'
import { useMeetingRoomL } from './meeting-room-l.ts'
import { useMeetingRoomM } from './meeting-room-m.ts'

export function useRooms(k: KAPLAYCtx) {
  const { setPrintRoom } = usePrintRoom(k)
  const { setFocusRoomA } = useFocusRoomA(k)
  const { setFocusRoomB } = useFocusRoomB(k)
  const { setTreadmillRoom } = useTreadmillRoom(k)
  const { setWC } = useWC(k)
  const { setWCB } = useWCB(k)
  const { setWCHandicap } = useWCHandicap(k)
  const { setWCFemale } = useWCFemale(k)
  const { setWCMale } = useWCMale(k)
  const { setWellbeingRoom } = useWellbeingRoom(k)
  const { setTrainingRoom } = useTrainingRoom(k)
  const { setMedicalRoom } = useMedicalRoom(k)
  const { setMothersRoom } = useMothersRoom(k)
  const { setGreenRoom } = useGreenRoom(k)
  const { setMultifaithRoom } = useMultifaithRoom(k)
  const { setMeetingRoomA } = useMeetingRoomA(k)
  const { setMeetingRoomB } = useMeetingRoomB(k)
  const { setMeetingRoomC } = useMeetingRoomC(k)
  const { setMeetingRoomD } = useMeetingRoomD(k)
  const { setMeetingRoomE } = useMeetingRoomE(k)
  const { setMeetingRoomF } = useMeetingRoomF(k)
  const { setMeetingRoomG } = useMeetingRoomG(k)
  const { setMeetingRoomH } = useMeetingRoomH(k)
  const { setMeetingRoomI } = useMeetingRoomI(k)
  const { setMeetingRoomJ } = useMeetingRoomJ(k)
  const { setMeetingRoomK } = useMeetingRoomK(k)
  const { setMeetingRoomL } = useMeetingRoomL(k)
  const { setMeetingRoomM } = useMeetingRoomM(k)

  return {
    setPrintRoom,
    setFocusRoomA,
    setFocusRoomB,
    setTreadmillRoom,
    setWC,
    setWCB,
    setWCHandicap,
    setWCFemale,
    setWCMale,
    setWellbeingRoom,
    setTrainingRoom,
    setMedicalRoom,
    setMothersRoom,
    setGreenRoom,
    setMultifaithRoom,
    setMeetingRoomA,
    setMeetingRoomB,
    setMeetingRoomC,
    setMeetingRoomD,
    setMeetingRoomE,
    setMeetingRoomF,
    setMeetingRoomG,
    setMeetingRoomH,
    setMeetingRoomI,
    setMeetingRoomJ,
    setMeetingRoomK,
    setMeetingRoomL,
    setMeetingRoomM,
  }
}
